/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalFileDto } from '../../models/external-file-dto';

export interface ExternalFilesDataSourceDataSourceIdGet$Json$Params {
  dataSourceId: string;
}

export function externalFilesDataSourceDataSourceIdGet$Json(http: HttpClient, rootUrl: string, params: ExternalFilesDataSourceDataSourceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalFileDto>>> {
  const rb = new RequestBuilder(rootUrl, externalFilesDataSourceDataSourceIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalFileDto>>;
    })
  );
}

externalFilesDataSourceDataSourceIdGet$Json.PATH = '/external-files/data-source/{dataSourceId}';
